import {
  addDays,
  torontoDate,
  torontoDowHour,
  torontoMidnight,
} from "../domain/time/toronto";
import type { DayRow } from "../reports/types";

export const todayRange = (now: Date) => ({
  from: torontoDate(now),
  to: torontoDate(now),
});
/** Monday (ISO week) to today, America/Toronto. */
export const weekRange = (now: Date) => {
  const today = torontoDate(now);
  return { from: addDays(today, 1 - torontoDowHour(now).dow), to: today };
};
export const last14Range = (now: Date) => ({
  from: addDays(torontoDate(now), -13),
  to: torontoDate(now),
});
export const startOfTodayIso = (now: Date) =>
  torontoMidnight(torontoDate(now)).toISOString();
export const endOfTodayIso = (now: Date) =>
  torontoMidnight(addDays(torontoDate(now), 1)).toISOString();

/** One row per day in [from, to]; days without calls get zeros. */
export const fillDays = (
  rows: readonly DayRow[],
  from: string,
  to: string,
): DayRow[] => {
  const byDay = new Map(rows.map((r) => [r.day, r]));
  const out: DayRow[] = [];
  for (let d = from; d <= to; d = addDays(d, 1))
    out.push(byDay.get(d) ?? { day: d, dials: 0, contacts: 0 });
  return out;
};
